let expandCardsButton = document.getElementById("expand-cards-button");
let expandedCards = document.querySelectorAll(".d-md-block-added-by-js");
let isExpanded = false;
expandCardsButton.addEventListener("click", function(event) {
    isExpanded = !isExpanded;
    if (isExpanded) {
        expandedCards.forEach((cardElement) => {
            cardElement.classList.add("d-md-block");
        });
        expandCardsButton.innerText=expandCardsButton.dataset.labelExpanded;
    } else {
        expandedCards.forEach((cardElement) => {
            cardElement.classList.remove("d-md-block");
        });
        expandCardsButton.innerText=expandCardsButton.dataset.labelNotExpanded;
    }
});

function changeTrustPilotRenderingOnConsent() {
    const hasAcceptedCookies = window.Didomi?.getCurrentUserStatus()?.purposes?.cookies?.enabled ?? false

    if(hasAcceptedCookies) {
        const script = document.createElement('script');
        script.src = "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";

        document.head.appendChild(script);

        Array.from(document.getElementsByClassName("MSH-trustPilotComments")).forEach((element) => {
            element.style.display = "block";
        })
    }
}

window.didomiOnReady = window.didomiOnReady || [];
window.didomiOnReady.push(function (Didomi) {
    changeTrustPilotRenderingOnConsent()

    // Wrapper qui écoute les changements de statut des vendors
    Didomi.on('consent.changed', function(notice) {
        changeTrustPilotRenderingOnConsent()
    });
});

